<template>
  <div class="gant">
    <gannt-mode @handleUpdateMode="handleUpdateMode"></gannt-mode>

    <div class="gantt-scroll-table">
      <div class="gantt-table-hide-scrollbar" ref="ganttHeadScroll">
        <gannt-header :header="tableHeaderData"></gannt-header>
      </div>

      <div class="gantt-table-body" ref="gantt">
        <gannt-body :body="rowInfoList" :header="tableHeaderData"></gannt-body>
      </div>
    </div>

    <!-- <div class="gantt-body" ref="gantt">
      <div>
        <gannt-header :header="tableHeaderData"></gannt-header>
      </div>
      <div>
        <gannt-body :body="rowInfoList" :header="tableHeaderData"></gannt-body>
      </div>
    </div> -->
    <div class="task-modal" ref="taskModalRef" :style="taskInfoStyle">
      <div>任务名称：{{ taskInfo.taskName }}</div>
      <div>任务完成率：{{ taskInfo.completionDegree }} %</div>
      <div>预计时间：{{ taskInfo.startTime }} ~ {{ taskInfo.endTime }}</div>
      <div>
        计划时间：{{ taskInfo.scheduledStartTime }} ~
        {{ taskInfo.scheduledEndTime }}
      </div>
      <div>
        实际时间：{{ taskInfo.actualReleaseStartTime }} ~
        {{ taskInfo.actualReleaseEndTime }}
      </div>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  provide,
  reactive,
  ref,
  watch,
} from "vue";
import {
  getGanntHeader,
  getMinOrMaxDateBylist,
} from "@/views/rdmanagement/components/customGantt/serve/index";
import {
  getMinMaxDates,
  getTaskInfo,
  gantt,
  deleteProgressTime,
  renderProgressTime,
  rednerRecordInfoDom,
  renderWeekendTime,
} from "@/views/rdmanagement/components/customGantt/serve/taskProcess";
import {
  rowSideLength as rectangularSide,
  rowSideLength,
  tableHeader,
} from "@/views/rdmanagement/components/customGantt/serve/options";
import { setPrjectSchemeScroll } from "@/views/rdmanagement/components/projectScheme/gannt";
import UseTooltip from "@/views/rdmanagement/components/customGantt/serve/toolip";
import ganntMode from "@/views/rdmanagement/components/customGantt/components/mode.vue";
import ganntHeader from "@/views/rdmanagement/components/customGantt/components/header.vue";
import ganntBody from "@/views/rdmanagement/components/customGantt/components/body.vue";
import { debounce } from "@/utils";

export default defineComponent({
  components: {
    ganntMode,
    ganntHeader,
    ganntBody,
  },
  props: {
    ganntConfig: Object,
  },
  setup(props) {
    const ganttHeadScroll = ref();

    const ganttConfig = reactive({
      startTime: null,
      endTime: null,
    });

    const mode = ref("day");
    provide("ganntHeaderMode", mode);

    const tableHeaderData = ref([]);

    const rowInfoList = ref([]);

    const {
      taskInfo,
      taskInfoStyle,
      showTaskInfo,
      updateTaskInfo,
      hideTaskInfo,
    } = UseTooltip();

    const PROCESSOFFSET = {
      day: 15,
      week: 0,
      month: 0,
    };

    const SIDE = {
      day: rectangularSide,
      week: rectangularSide,
      month: 74,
    };

    // 渲染周
    const renderWeekend = () => {
      const weekendIndex = [];
      let dayNum = 0;
      tableHeaderData.value.forEach((item) => {
        if (item.children && item.children.length > 0) {
          item.children.forEach((subItem) => {
            const { weekendList, dayList } = subItem;

            weekendList.forEach((weekend) => {
              weekendIndex.push(weekend + dayNum);
            });
            dayNum += dayList.length;
          });
        }
      });

      weekendIndex.forEach((item) => {
        const positionInfo = {
          left: item * rowSideLength + 1,
          width: rowSideLength - 1,
          top: 1,
          height:( rowInfoList.value.length  * rowSideLength) - 2,
        };

        renderWeekendTime(positionInfo);
      });
    };

    const renderGannt = () => {
      deleteProgressTime();

      
      const processOffset = PROCESSOFFSET[mode.value];

      const rowSideLength = SIDE[mode.value];
      rowInfoList.value.forEach((item, index) => {
        const [{ year, startMonth }] = tableHeaderData.value;

        const recordHeight = tableHeader + index * rectangularSide;
        if (item.ifShow) {
          const { startTime, endTime } = item;

          const { taskLeft, taskWidth } = getTaskInfo(
            { year, startMonth, startTime, endTime },
            mode.value
          );

          const positionInfo = {
            left: taskLeft * rowSideLength + processOffset,
            width: taskWidth * rowSideLength,
            top: recordHeight + 5,
          };
          renderProgressTime(positionInfo, item);
        }

        if (item.type === "release" && item.ifShow) {
          const startTime = getMinOrMaxDateBylist(
            [
              item.startTime,
              item.scheduledStartTime,
              item.actualReleaseStartTime,
            ],
            "min"
          );

          const endTime = getMinOrMaxDateBylist(
            [item.endTime, item.scheduledEndTime, item.actualReleaseEndTime],
            "max"
          );

          const { taskLeft, taskWidth } = getTaskInfo(
            { year, startMonth, startTime, endTime },
            mode.value
          );
          rednerRecordInfoDom(
            {
              positionInfo: {
                left: taskLeft * rowSideLength + processOffset,
                width: taskWidth * rowSideLength + 32,
                top: recordHeight,
              },
              updateTaskInfo,
              hideTaskInfo,
              showTaskInfo,
            },
            item
          );
        }
      });

      renderWeekend();
    };

    const updateGannt = () => {
      nextTick(() => renderGannt());
    };

    // 更新表头
    const updateGanntHeader = () => {
      tableHeaderData.value.length = 0;
      if (ganttConfig.startTime && ganttConfig.endTime) {
        const header = getGanntHeader(
          ganttConfig.startTime,
          ganttConfig.endTime,
          mode.value
        );
        tableHeaderData.value.push(...header);
      }
    };

    // 更新时间
    const updateGanntConfig = (list) => {
      const { startTime, endTime, rowList } = getMinMaxDates(list);
      if (startTime && endTime) {
        ganttConfig.startTime = startTime;
        ganttConfig.endTime = endTime;
        rowInfoList.value.push(...rowList);
      }
    };

    const handleUpdateMode = (val) => {
      if (mode.value === val) return;
      mode.value = val;
      updateGanntHeader();
      updateGannt();
    };

    const updateGanntScroll = () => {
      if (props.ganntConfig && props.ganntConfig.calcHeight) {
        // const calcHeight =
        //   props.ganntConfig.calcHeight > 1
        //     ? 1 - props.ganntConfig.calcHeight
        //     : props.ganntConfig.calcHeight;
        const scrollTop = Math.abs(props.ganntConfig.calcHeight) * 93;

        gantt.value.scrollTop = scrollTop;
      }
    };

    const setGanttHeaderScroll = (scrollLeft) => {
      ganttHeadScroll.value.scrollLeft = scrollLeft;
    };

    const setProjectSchemeScroll = (scrollTop) => {
      console.log(scrollTop);
    };

    const scrollRecord = {
      x: 0,
      y: 0,
    };

    const directCondition = (scrollLeft, scrollTop) => {
      if (scrollRecord.x !== scrollLeft) {
        setGanttHeaderScroll(scrollLeft);
      }

      if (scrollRecord.y !== scrollTop) {
        // setProjectSchemeScroll(scrollTop);
        setPrjectSchemeScroll(scrollTop);
      }

      scrollRecord.x = scrollLeft;
      scrollRecord.y = scrollTop;
    };

    onMounted(() => {
      gantt.value.addEventListener("scroll", (e) => {
        directCondition(e.target.scrollLeft, e.target.scrollTop);
      });
    });

    watch(
      () => props.ganntConfig,
      (val) => {
        rowInfoList.value.length = 0;
        if (val.list.length > 0) {
          nextTick(() => {
            updateGanntConfig(val.list);
            updateGanntHeader();
            updateGannt();
            updateGanntScroll();
          });
        }
      },
      {
        deep: true,
      }
    );

    return {
      handleUpdateMode,
      updateGannt,
      ganttHeadScroll,
      gantt,
      taskInfo,
      tableHeaderData,
      taskInfoStyle,
      rowInfoList,
    };
  },
});
</script>

<style scoped lang="less">
.gant {
  width: 100vw;

  .gantt-body {
    position: relative;
    max-height: calc(100vh - 121px);
    overflow: auto scroll;
    padding-top: 88px;
    .gantt-header {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
}

.gantt-scroll-table {
  overflow: auto;
  overflow-x: hidden;
  .gantt-table-hide-scrollbar {
    margin-bottom: -17px;
    padding-bottom: 0px;
    min-width: 17px;
    overflow: scroll;
  }
  .gantt-table-hide-scrollbar ::-webkit-scrollbar-track {
    background-color: transparent; /* 设置滚动条背景色 */
  }

  .gantt-table-hide-scrollbar ::-webkit-scrollbar-thumb {
    background-color: transparent; /* 设置滑块颜色 */
  }

  /* Firefox浏览器 */
  .gantt-table-hide-scrollbar * {
    scrollbar-color: transparent transparent; /* 设置滑块颜色及背景色 */
  }
  .gantt-table-body {
    position: relative;
    max-height: calc(100vh - 209px);
    overflow: auto scroll;
  }
}

.task-modal {
  background: #fff;
  width: 300px;
  padding: 10px;
  box-shadow: 0 0 10px 2px #ccc;
  display: none;
  position: absolute;
  border-radius: 10px;
  z-index: 3;
}
</style>
